import React, { useState } from "react";
import { Layout, Menu, Drawer, Button, Grid } from "antd";
import {
  MenuOutlined,
  DashboardOutlined,
  UserOutlined,
  SettingOutlined,
  PlusOutlined,
  EyeOutlined,
  PayCircleOutlined,
  ProjectOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { Outlet } from "react-router-dom";
import { useAuth } from "../context/Authcontext";
import AppHeader from "./Header";
const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;
const DashboardLayout = ({ children }) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();
  const navigate = useNavigate();

  const menuItems = [
    {
      key: "1",
      icon: <DashboardOutlined />,
      label: "Dashboard",
      onClick: () => navigate("/"),
    },
    {
      key: "2",
      icon: <UserOutlined />,
      label: "Users",
      // onClick: () => navigate("/users"),
      children: [
        {
          key: "4-1",
          icon: <PlusOutlined />,
          label: "Create User",
          onClick: () => navigate("/user/createuser"),
        },
        {
          key: "4-2",
          icon: <EyeOutlined />,
          label: "View users",
          onClick: () => navigate("/user/viewUser"),
        },
      ].filter(Boolean),
    },

     {
      key: "4",
      icon: <SettingOutlined />,
      label: "Role",
      onClick: () => navigate("/role"),
    },
    {
      key: "5",
      icon: <ProjectOutlined />,
      label: "Brand",
      // onClick: () => navigate("/users"),
      children: [
        {
          key: "5-1",
          icon: <PlusOutlined />,
          label: "Add Brand",
          onClick: () => navigate("/tenant/create"),
        },
         {
          key: "5-2",
          icon: <EyeOutlined />,
          label: "View Brand",
          onClick: () => navigate("/tenant/view"),
        },
      ].filter(Boolean),
    },
    {
      key: "14",
      icon: <ProjectOutlined />,
      label: "Franchise",
      // onClick: () => navigate("/users"),
      children: [
        {
          key: "14-1",
          icon: <PlusOutlined />,
          label: "Add Franchise",
          onClick: () => navigate("/company/create"),
        },
         {
          key: "14-2",
          icon: <EyeOutlined />,
          label: "View Franchise",
          onClick: () => navigate("/company/view"),
        },
      ].filter(Boolean),
    },
    // {
    //   key: "6",
    //   icon: <PayCircleOutlined />,
    //   label: "Payrole",
    //   onClick: () => navigate("/payrole"),
    //   // children: [
    //   //   {
    //   //     key: "6-1",
    //   //     icon: <PlusOutlined />,
    //   //     label: "View payrole",
    //   //     onClick: () => navigate("/payrole/create"),
    //   //   },
    //   //   {
    //   //     key: "6-2",
    //   //     icon: <EyeOutlined />,
    //   //     label: "Edit payroles",
    //   //     onClick: () => navigate("/payrole/view"),
    //   //   },
    //   // ],
    // },
   
    {
      key: "8",
      icon: <ProjectOutlined />,
      label: "Reports",
      // onClick: () => navigate("/users"),
      children: [
        {
          key: "8-1",
          icon: <PlusOutlined />,
          label: "company Revenue",
          onClick: () => navigate("/reports/companyRevenue"),
        },
        {
          key: "8-2",
          icon: <PlusOutlined />,
          label: "Tenant Revenue",
          onClick: () => navigate("/reports/tenantRevenue"),
        },
         {
          key: "8-3",
          icon: <PlusOutlined />,
          label: "Staff Report",
          onClick: () => navigate("/reports/staffReport"),
        },
       
        // {
        //   key: "8-2",
        //   icon: <EyeOutlined />,
        //   label: "View Projects",
        //   onClick: () => navigate("/project/view"),
        // },
      ],
    },
     {
      key: "9",
      icon: <ProjectOutlined />,
      label: "Location",
      onClick: () => navigate("/location"),
     }
     
   
    //  {
    //   key: "10",
    //   icon: <SettingOutlined />,
    //   label: "Booking",
    //   // onClick: () => navigate("/message"),
    //    children: [
    //     {
    //       key: "10-1",
    //       icon: <PlusOutlined />,
    //       label: "Car Booking",
    //       onClick: () => navigate("/carBooking/book"),
    //     },
    //     {
    //       key: "10-2",
    //       icon: <EyeOutlined />,
    //       label: "List",
    //       onClick: () => navigate("/carBooking/list"),
    //     },
    //     {
    //       key: "10-3",
    //       icon: <EyeOutlined />,
    //       label: "View",
    //       onClick: () => navigate("/carBooking/view"),
    //     },
    //   ],
      
    // },
  ].filter(Boolean);

  const renderMenu = () => (
    <Menu
      theme="dark"
      mode="inline"
      defaultSelectedKeys={["1"]}
      items={menuItems}
      style={{ height: "100%", borderRight: 0 }}
    />
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {screens.md ? (
        <Sider collapsible>{renderMenu()}</Sider>
      ) : (
        <Drawer
          title="Menu"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          {renderMenu()}
        </Drawer>
      )}

      <Layout>
        {/* <Header
          style={{
            background: "#fff",
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
          }}
        >
          {!screens.md && (
            <Button
              icon={<MenuOutlined />}
              type="text"
              onClick={() => setDrawerVisible(true)}
            />
          )}
          <h1 style={{ margin: 0, fontSize: "18px" }}>My Dashboard</h1>
        </Header> */}
        <AppHeader onMenuClick={() => setDrawerVisible(true)} />
        <Content style={{ margin: "16px" }}>
          <div
            style={{
              padding: 24,
              background: "#fff",
              minHeight: 360,
              borderRadius: 8,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            }}
          >
            {/* {children} */}
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
